import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { RouteError, RouteLoading } from "../shared/PageState";

export default function SignupOtpSettings() {
  const cache = useQueryClient();
  const query = useQuery({ queryKey: ["signup-otp-settings"], queryFn: api.getSignupOtpSettings });
  const update = useMutation({
    mutationFn: api.updateSignupOtpSettings,
    onSuccess: data => {
      cache.setQueryData(["signup-otp-settings"], data);
      void cache.invalidateQueries({ queryKey: ["tech-admin-audit"] });
    }
  });
  if (query.isPending) return <RouteLoading />;
  if (query.error || !query.data) return <RouteError title="Signup settings unavailable"
    detail={query.error?.message ?? "Could not load signup settings."} onRetry={() => void query.refetch()} />;
  const { enabled, proxy_mobile_number: mobile } = query.data;
  return <section className="pa-page-stack">
    <div className="pa-title-row"><div><h2>Signup OTP delivery</h2>
      <p>Control OTP delivery for mobile numbers that have not signed up yet.</p></div></div>
    <div className="pa-organization-settings-group">
      <div className="pa-organization-setting-row">
        <div className="pa-organization-setting-main">
          <div className="pa-organization-setting-copy">
            <strong id="signup-otp-proxy-label">Send signup OTPs to the test proxy</strong>
            <small id="signup-otp-proxy-description">When enabled, send OTPs to {mobile}. When disabled, send them to the number entered by the user.</small>
            <small>Existing-user logins, their test proxy mappings, and Ops sign-in are unchanged.</small>
          </div>
          <button type="button" role="switch" aria-checked={enabled} aria-labelledby="signup-otp-proxy-label"
            aria-describedby="signup-otp-proxy-description" className={`pa-settings-switch${enabled ? " active" : ""}`}
            disabled={update.isPending} onClick={() => update.mutate(!enabled)}><span /></button>
        </div>
        <div className="pa-form-note" role="status">{update.isPending ? "Saving…" : enabled ? `Enabled · OTPs go to ${mobile}` : "Disabled · OTPs go to the signup number"}</div>
        {update.error ? <p className="pa-form-error" role="alert">{update.error.message}</p> : null}
      </div>
    </div>
  </section>;
}
